/* eslint-disable jsx-a11y/iframe-has-title */
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";

const placeholderVideo =
  "https://player.vimeo.com/video/555599366?h=69a13eb56d";
const placeholderLogo =
  "https://media.zbooni.shop/assets/web/marketplace/logo/herbake.jpg";

const CardListItem = ({ video, tag, logo, title, location }) => {
  const { t: trans } = useTranslation();
  return (
    <div
      className="relative h-[270px] w-[280px] overflow-hidden
      rounded-2xl bg-white"
    >
      <div className="relative h-[166px] w-full overflow-hidden">
        <iframe
          src={video ? video : placeholderVideo}
          height="300"
          className="absolute left-[-10px] top-[-45px] block"
        />
      </div>
      <div className="absolute bottom-2">
        <div
          className="w-fit rounded-xl bg-cyan-lightest px-3 py-1 ltr:ml-4 
          rtl:mr-4"
        >
          <h3 className="text-center text-xs rtl:font-montserrat">
            {trans(tag)}
          </h3>
        </div>
        <div className="mt-2 flex items-center ltr:ml-4 rtl:mr-4">
          <img
            alt=""
            src={logo ? logo : placeholderLogo}
            className="h-[50px] w-[50px] rounded-[50%] object-cover ltr:mr-2 
            rtl:ml-2"
          />
          <span className="text-sm">
            <h3 className="font-bold leading-4 rtl:font-montserrat">{title}</h3>
            <p className="rtl:font-montserrat">{location}</p>
          </span>
        </div>
      </div>
    </div>
  );
};

CardListItem.propTypes = {
  video: PropTypes.string,
  tag: PropTypes.string,
  logo: PropTypes.string,
  title: PropTypes.string,
  location: PropTypes.string,
};

export default CardListItem;
